import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */

/* eslint-disable @typescript-eslint/unbound-method */
import { css, jsx } from '@emotion/react';
import { Menu } from '@flowio/react-menu';
import { Paper } from '@flowio/react-paper';
import { TagInput } from '@flowio/react-tag-input';
import { findDOMNode } from 'react-dom';
import { isHTMLElement } from '@flowio/browser-helpers';
import { Popover } from '@flowio/react-popover';
import React from 'react';
import caseInsensitiveFilter from '../utilities/caseInsensitiveFilter';
import isTouchCapable from '../utilities/isTouchCapable';
var defaultProps = {
  blurOnSelection: isTouchCapable(),
  closeOnClickAway: true,
  closeOnEscape: true,
  closeOnInvisible: false,
  closeOnResize: false,
  closeOnScroll: false,
  closeOnSelection: false,
  constraint: 'flipfit flipfit',
  defaultInputValue: '',
  defaultOpen: false,
  defaultValue: [],
  disabled: false,
  filterOption: caseInsensitiveFilter,
  fluid: false,
  intent: 'neutral',
  loading: false,
  loadingMessage: 'Loading...',
  lockScrolling: true,
  maxMenuHeight: 300,
  minimumCharacters: 1,
  noOptionsMessage: 'No options',
  offset: '0px 2px',
  openOnClick: true,
  openOnFocus: true,
  openOnHover: false,
  openOnSpace: false,
  options: [],
  position: 'bottom left',
  resetInputOnChange: true,
  searchable: true,
  size: 'medium',
  readOnly: false
};

function getInitialState(props) {
  return {
    inputValue: props.inputValue != null ? props.inputValue : props.defaultInputValue,
    minWidth: 'auto',
    open: props.open != null ? props.open : props.defaultOpen,
    value: props.value != null ? props.value : props.defaultValue
  };
}

function getDerivedStateFromProps(props, state) {
  return {
    inputValue: props.inputValue != null ? props.inputValue : state.inputValue,
    minWidth: state.minWidth,
    open: props.open != null ? props.open : state.open,
    value: props.value != null ? props.value : state.value
  };
}

var loadingMessageStyles = process.env.NODE_ENV === "production" ? {
  name: "sxkfp0",
  styles: "display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;min-height:32px;padding:8px 16px;box-sizing:border-box;color:#b5bec9;cursor:pointer;font-size:0.875rem;user-select:none"
} : {
  name: "z33856-loadingMessageStyles",
  styles: "display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;min-height:32px;padding:8px 16px;box-sizing:border-box;color:#b5bec9;cursor:pointer;font-size:0.875rem;user-select:none;label:loadingMessageStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var noOptionsMessageStyles = loadingMessageStyles;

var MultiSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiSelect, _React$Component);

  var _super = _createSuper(MultiSelect);

  function MultiSelect(props) {
    var _this;

    _classCallCheck(this, MultiSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "tagInputRef", void 0);

    _this.state = getInitialState(props);
    _this.tagInputRef = /*#__PURE__*/React.createRef();
    _this.handleInputValueChange = _this.handleInputValueChange.bind(_assertThisInitialized(_this));
    _this.handleMenuItemSelection = _this.handleMenuItemSelection.bind(_assertThisInitialized(_this));
    _this.handleMenuMouseDown = _this.handleMenuMouseDown.bind(_assertThisInitialized(_this));
    _this.handlePopoverClose = _this.handlePopoverClose.bind(_assertThisInitialized(_this));
    _this.handlePopoverOpen = _this.handlePopoverOpen.bind(_assertThisInitialized(_this));
    _this.handleTagInputRemove = _this.handleTagInputRemove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MultiSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMinWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateMinWidth();
    }
  }, {
    key: "handlePopoverOpen",
    value: function handlePopoverOpen() {
      this.open();
    }
  }, {
    key: "handlePopoverClose",
    value: function handlePopoverClose() {
      this.close();
    }
  }, {
    key: "handleMenuItemSelection",
    value: function handleMenuItemSelection(index, value) {
      var options = this.props.options;
      var option = options[index];

      if (value != null) {
        this.selectValue(value);
      } else if (option != null) {
        this.selectValue(option.value);
      }

      this.closeOnSelection();
      this.blurOnSelection();
    }
  }, {
    key: "handleMenuMouseDown",
    value: function handleMenuMouseDown(event) {
      var openOnFocus = this.props.openOnFocus;
      /*
        By default, a popover that opens on focus will close itself when focus
        is lost to an element that isn't within the popover, including its trigger
        element. However, menus don't receive focus on interaction and the popover
        will close. To prevent this behavior we stop the mouse event.
         We don't allow focus on the menu element for usability reasons. That is,
        we prefer for the next tab to shift focus to the next control element
        in a form instead of the menu.
      */

      if (openOnFocus) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: "handleInputValueChange",
    value: function handleInputValueChange(value) {
      this.changeInputValue(value);
      this.open();
    }
  }, {
    key: "handleTagInputRemove",
    value: function handleTagInputRemove(value) {
      this.removeValues(value);
    }
  }, {
    key: "getMenuStyle",
    value: function getMenuStyle() {
      var _this$props = this.props,
          menuProps = _this$props.menuProps,
          maxMenuHeight = _this$props.maxMenuHeight;
      var minWidth = this.state.minWidth;
      var menuStyle = {
        maxHeight: maxMenuHeight,
        minWidth: minWidth
      };

      if (menuProps == null) {
        return menuStyle;
      }

      return _objectSpread(_objectSpread({}, menuProps.style), menuStyle);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this2 = this;

      var _this$props2 = this.props,
          filterOption = _this$props2.filterOption,
          minimumCharacters = _this$props2.minimumCharacters,
          options = _this$props2.options,
          searchable = _this$props2.searchable;
      var inputValue = this.state.inputValue;
      return options.filter(function (option) {
        return !_this2.isValueSelected(option.value);
      }).filter(function (option) {
        return !searchable || inputValue.length < minimumCharacters || filterOption(option, inputValue);
      });
    }
  }, {
    key: "updateMinWidth",
    value: function updateMinWidth() {
      var currentMinWidth = this.state.minWidth; // Fixing this will be interesting because this component wants a ref to
      // both the root and input elements of the taginput component.
      // eslint-disable-next-line react/no-find-dom-node

      var tagInputNode = findDOMNode(this.tagInputRef.current);

      if (tagInputNode != null && isHTMLElement(tagInputNode)) {
        var minWidth = tagInputNode.clientWidth;

        if (minWidth !== currentMinWidth) {
          this.setState({
            minWidth: minWidth
          });
        }
      }
    }
  }, {
    key: "isInputValueControlled",
    value: function isInputValueControlled() {
      var inputValue = this.props.inputValue;
      return inputValue != null;
    }
  }, {
    key: "isOpenControlled",
    value: function isOpenControlled() {
      var open = this.props.open;
      return open != null;
    }
  }, {
    key: "isValueControlled",
    value: function isValueControlled() {
      var value = this.props.value;
      return value != null;
    }
  }, {
    key: "isValueSelected",
    value: function isValueSelected(value) {
      var selectedValues = this.state.value;
      return selectedValues.indexOf(value) >= 0;
    }
  }, {
    key: "blur",
    value: function blur() {
      if (this.tagInputRef.current != null) {
        this.tagInputRef.current.blur();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.tagInputRef.current != null) {
        this.tagInputRef.current.focus();
      }
    }
  }, {
    key: "open",
    value: function open() {
      var onOpen = this.props.onOpen;

      if (!this.isOpenControlled()) {
        this.setState({
          open: true
        });
      }

      if (typeof onOpen === 'function') {
        onOpen();
      }
    }
  }, {
    key: "close",
    value: function close() {
      var onClose = this.props.onClose;

      if (!this.isOpenControlled()) {
        this.setState({
          open: false
        });
      }

      if (typeof onClose === 'function') {
        onClose();
      }
    }
  }, {
    key: "blurOnSelection",
    value: function blurOnSelection() {
      var blurOnSelection = this.props.blurOnSelection;

      if (blurOnSelection) {
        this.blur();
      }
    }
  }, {
    key: "closeOnSelection",
    value: function closeOnSelection() {
      var closeOnSelection = this.props.closeOnSelection;

      if (closeOnSelection) {
        this.close();
      }
    }
  }, {
    key: "resetInputOnChange",
    value: function resetInputOnChange() {
      var _this$props3 = this.props,
          searchable = _this$props3.searchable,
          readOnly = _this$props3.readOnly,
          resetInputOnChange = _this$props3.resetInputOnChange;

      if ((searchable || !readOnly) && resetInputOnChange) {
        this.changeInputValue('');
      }
    }
  }, {
    key: "changeValue",
    value: function changeValue(value) {
      var onValueChange = this.props.onValueChange;

      if (!this.isValueControlled()) {
        this.setState({
          value: value
        });
      }

      if (typeof onValueChange === 'function') {
        onValueChange(value);
      }

      this.resetInputOnChange();
    }
  }, {
    key: "changeInputValue",
    value: function changeInputValue(value) {
      var onInputValueChange = this.props.onInputValueChange;

      if (!this.isInputValueControlled()) {
        this.setState({
          inputValue: value
        });
      }

      if (typeof onInputValueChange === 'function') {
        onInputValueChange(value);
      }
    }
  }, {
    key: "addValue",
    value: function addValue(value) {
      var selectedValues = this.state.value;
      this.changeValue(selectedValues.concat(value));
    }
  }, {
    key: "removeValue",
    value: function removeValue(value) {
      this.removeValues([value]);
    }
  }, {
    key: "removeValues",
    value: function removeValues(values) {
      var selectedValues = this.state.value;
      var filteredValues = selectedValues.filter(function (selectedValue) {
        return values.indexOf(selectedValue) === -1;
      });
      this.changeValue(filteredValues);
    }
  }, {
    key: "selectValue",
    value: function selectValue(value) {
      if (this.isValueSelected(value)) {
        this.removeValue(value);
      } else {
        this.addValue(value);
      }
    }
  }, {
    key: "renderControl",
    value: function renderControl() {
      var _this3 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          disabled = _this$props4.disabled,
          fluid = _this$props4.fluid,
          hintText = _this$props4.hintText,
          intent = _this$props4.intent,
          size = _this$props4.size,
          tagInputProps = _this$props4.tagInputProps,
          readOnly = _this$props4.readOnly,
          options = _this$props4.options;
      var _this$state = this.state,
          inputValue = _this$state.inputValue,
          value = _this$state.value;
      var diplayValue = options.filter(function (o) {
        return value.includes(o.value);
      }).map(function (o) {
        return o.content;
      });

      var handleOnRemove = function handleOnRemove(event) {
        var _options$find;

        var valueSelected = event[0];
        var valueToRemove = (_options$find = options.find(function (o) {
          return o.content === valueSelected;
        })) === null || _options$find === void 0 ? void 0 : _options$find.value;
        if (valueToRemove) _this3.handleTagInputRemove([valueToRemove]);
      };

      return jsx(TagInput, _extends({}, tagInputProps, {
        addKeyCodes: [],
        className: className,
        disabled: disabled,
        fluid: fluid,
        hintText: hintText,
        inputValue: inputValue,
        intent: intent,
        onInputValueChange: this.handleInputValueChange,
        onRemove: handleOnRemove,
        readOnly: readOnly,
        ref: this.tagInputRef,
        size: size,
        value: diplayValue
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this$props5 = this.props,
          loading = _this$props5.loading,
          loadingMessage = _this$props5.loadingMessage,
          menuProps = _this$props5.menuProps,
          noOptionsMessage = _this$props5.noOptionsMessage;
      var value = this.state.value;
      var options = this.getOptions();

      if (options.length > 0) {
        return jsx(Menu, _extends({}, menuProps, {
          multiple: true,
          items: options,
          onItemSelection: this.handleMenuItemSelection,
          onMouseDown: this.handleMenuMouseDown,
          style: this.getMenuStyle(),
          value: value
        }));
      }

      if (loading) {
        return jsx(Paper, {
          css: loadingMessageStyles,
          style: this.getMenuStyle()
        }, loadingMessage);
      }

      return jsx(Paper, {
        css: noOptionsMessageStyles,
        style: this.getMenuStyle()
      }, noOptionsMessage);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          closeOnClickAway = _this$props6.closeOnClickAway,
          closeOnEscape = _this$props6.closeOnEscape,
          closeOnInvisible = _this$props6.closeOnInvisible,
          closeOnResize = _this$props6.closeOnResize,
          closeOnScroll = _this$props6.closeOnScroll,
          constraint = _this$props6.constraint,
          disabled = _this$props6.disabled,
          lockScrolling = _this$props6.lockScrolling,
          offset = _this$props6.offset,
          openOnClick = _this$props6.openOnClick,
          openOnFocus = _this$props6.openOnFocus,
          openOnHover = _this$props6.openOnHover,
          openOnSpace = _this$props6.openOnSpace,
          popoverProps = _this$props6.popoverProps,
          position = _this$props6.position;
      var open = this.state.open;
      return jsx(Popover, _extends({}, popoverProps, {
        closeOnClickAway: closeOnClickAway,
        closeOnEscape: closeOnEscape,
        closeOnInvisible: closeOnInvisible,
        closeOnResize: closeOnResize,
        closeOnScroll: closeOnScroll,
        constraint: constraint,
        disabled: disabled,
        lockScrolling: lockScrolling,
        offset: offset,
        onClose: this.handlePopoverClose,
        onOpen: this.handlePopoverOpen,
        open: open,
        openOnClick: openOnClick,
        openOnFocus: openOnFocus,
        openOnHover: openOnHover,
        openOnSpace: openOnSpace,
        position: position,
        trigger: this.renderControl()
      }), this.renderMenu());
    }
  }]);

  return MultiSelect;
}(React.Component);

_defineProperty(MultiSelect, "displayName", 'MultiSelect');

_defineProperty(MultiSelect, "defaultProps", defaultProps);

_defineProperty(MultiSelect, "getDerivedStateFromProps", getDerivedStateFromProps);

export default MultiSelect;